import DeviceInfo from 'react-native-device-info';
import { Platform } from 'utils/platform';

function isUnknown(value: string | null | undefined): boolean {
  return !value || value.toLowerCase() === 'unknown';
}

function shortenText(value: string, max = 400): string {
  if (value.length <= max) return value;
  return `${value.slice(0, max - 1)}…`;
}

function getWebUserAgent(): string {
  if (typeof navigator === 'undefined') return '';
  return navigator.userAgent || '';
}

function getWebOsHint(ua: string): string {
  if (/Windows NT 10\.0/i.test(ua)) return 'Windows 10/11';
  if (/Windows NT 6\.3/i.test(ua)) return 'Windows 8.1';
  if (/Mac OS X (\d+[._]\d+)/i.test(ua)) {
    const m = ua.match(/Mac OS X (\d+[._]\d+)/i);
    return m ? `macOS (${m[1].replace('_', '.')})` : 'macOS';
  }
  if (/Android (\d+)/i.test(ua)) {
    const m = ua.match(/Android (\d+)/i);
    return m ? `Android ${m[1]}` : 'Android';
  }
  if (/CPU iPhone OS|iPhone OS/i.test(ua)) {
    const m = ua.match(/(?:CPU )?iPhone OS ([\d_]+)/i);
    return m ? `iOS ${m[1].replace(/_/g, '.')}` : 'iOS';
  }
  if (/Linux/i.test(ua)) return 'Linux';
  return '—';
}

/**
 * Bloco de contexto para “Informar problema”.
 * Na web, `DeviceInfo` costuma retornar `unknown` — usamos User-Agent e heurística de SO.
 */
export function getReportEmailDeviceBlock(): string {
  if (Platform.OS !== 'web') {
    const brand = DeviceInfo.getBrand();
    const model = DeviceInfo.getModel();
    const deviceParts = [brand, model].filter((p) => !isUnknown(p));
    let device = deviceParts.length ? deviceParts.join(' ') : `${brand} ${model}`.trim();
    if (isUnknown(brand) && isUnknown(model)) {
      device = 'não identificado';
    }

    const systemVersion = DeviceInfo.getSystemVersion();
    const system = `${Platform.OS}${isUnknown(systemVersion) ? '' : ` ${systemVersion}`}`;

    return `Dados do dispositivo:\nDispositivo: ${device}\nSistema: ${system}`;
  }

  const ua = getWebUserAgent();
  const osHint = getWebOsHint(ua);
  const uaLine = ua ? shortenText(ua) : '—';

  return [
    'Dados do ambiente (web):',
    ua ? `User-Agent: ${uaLine}` : 'User-Agent: —',
    `Sistema: web (${osHint})`,
  ].join('\n');
}
